module.exports = __webpack_public_path__ + "static/media/computerSts.bccb7614.jpg";